import { render, staticRenderFns } from "./SlotsCreationForm.vue?vue&type=template&id=155527f3&scoped=true&"
import script from "./SlotsCreationForm.vue?vue&type=script&lang=js&"
export * from "./SlotsCreationForm.vue?vue&type=script&lang=js&"
import style0 from "./SlotsCreationForm.vue?vue&type=style&index=0&id=155527f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155527f3",
  null
  
)

export default component.exports